import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { EcmRouterModule, Link, LinkService, TrackingData } from '@ecm/router';

import { ContractV7Offer } from '../../../business/api/dashboardV7/contract/contractV7Offer';
import { LasBillViewModel } from '../../../business/model/home/lastBill.view-model';

@Component({
    selector: 'ecm-section-bill',
    templateUrl: 'section-bill.component.html',
    styleUrls: ['section-bill.component.css'],
    standalone: true,
    imports: [RouterLink, AsyncPipe, DatePipe, EcmRouterModule, TranslateModule],
})
export class SectionBillComponent {
    private readonly linkService = inject(LinkService);

    @Input()
    public bill!: LasBillViewModel;
    @Input()
    public offer!: ContractV7Offer;

    public openLink(link: Link, tmsTracking: TrackingData) {
        this.linkService.openLink(link, tmsTracking);
    }
}
